import { inject, Injectable } from '@angular/core';
import { NoAuthHttpService } from '@core/services/no-auth-http.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ReportDownloadUseCaseService {
  private readonly noAuth = inject(NoAuthHttpService);

  execute(fileUrl: string): Observable<Blob> {
    return this.noAuth.http.get(fileUrl, { responseType: 'blob' }).pipe(
      tap(blob => {
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileUrl.split('/').pop()!.split('?')[0];
        document.body.appendChild(a);
        a.click();
        a.remove();
        globalThis.URL.revokeObjectURL(url);
      })
    );
  }
}
